import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Clients from '@/components/Clients'
import addClient from '@/components/ClientAdd'
import ClientDetails from '@/components/ClientDetails'
import Config from '@/components/Config'
import Domains from '@/components/Domains'
import Email from '@/components/Email'
import Sites from '@/components/Sites'
import Billing from '@/components/Billing'
import Services from '@/components/Services'
import Products from '@/components/Products'
import addProduct from '@/components/addProduct'
import Invoices from '@/system/pages/all-invoices'
import invoiceDetails from '@/components/invoiceDetails'
import addInvoice from '@/components/addInvoice'
import Subscriptions from '@/components/Subscriptions'
import addSubscription from '@/components/addSubscription'
import Support from '@/components/Support'
import Cart from '@/components/Cart'
import checkoutSuccess from '@/components/checkoutSuccess'
import cmsDash from '@/components/cms/cmsDash'
import cmsPages from '@/components/cms/cmsPages'
import cmsSettings from '@/components/cms/cmsSettings'
import cmsSettingsUser from '@/components/cms/cmsSettingsUser'
import cmsLeads from '@/components/cms/cmsLeads'
import cmsColors from '@/components/cms/cmsColors'
import cmsNews from '@/components/cms/cmsNews'
import cmsNewsDetail from '@/components/cms/cmsNewsDetail'
import cmsProperties from '@/components/cms/cmsProperties'
import cmsPropertiesDetail from '@/components/cms/cmsPropertiesDetail'
import cmsPropertiesUnitsDetail from '@/components/cms/cmsPropertiesUnitsDetail'
import cmsPropertiesLandDetail from '@/components/cms/cmsPropertiesLandDetail'
import cmsTestimonials from '@/components/cms/cmsTestimonials'
import cmsTestimonialsDetail from '@/components/cms/cmsTestimonialsDetail'
import cmsPartners from '@/components/cms/cmsPartners'
import cmsPartnersDetail from '@/components/cms/cmsPartnersDetail'
import cmsCustomPagesDetail from '@/components/cms/cmsCustomPagesDetail'
import cmsFaqs from '@/components/cms/cmsFaqs'
import cmsFaqsDetail from '@/components/cms/cmsFaqsDetail'
import cmsProducts from '@/components/cms/cmsProducts'
import cmsProductsDetail from '@/components/cms/cmsProductsDetail'
import cmsProductCategories from '@/components/cms/cmsProductCategories'
import cmsProductCategoriesDetail from '@/components/cms/cmsProductCategoriesDetail'
import cmsProductOrders from '@/components/cms/cmsProductOrders'
import cmsOrderDetail from '@/components/cms/cmsProductOrderDetail'
import cmsServices from '@/components/cms/cmsServices'
import cmsServicesDetail from '@/components/cms/cmsServicesDetail'
import cmsPortfolio from '@/components/cms/cmsPortfolio'
import cmsPortfolioCategories from '@/components/cms/cmsPortfolioCategories'
import cmsPortfolioDetail from '@/components/cms/cmsPortfolioDetail'
import cmsTeam from '@/components/cms/cmsTeam'
import cmsTeamDetail from '@/components/cms/cmsTeamDetail'
import cmsPhotos from '@/components/cms/cmsPhotos'
import cmsPhotoDetail from '@/components/cms/cmsPhotoDetail'
import cmsDocuments from '@/components/cms/cmsDocuments'
import cmsDocumentsDetail from '@/components/cms/cmsDocumentsDetail'
import cmsPaypal from '@/components/cms/cmsPaypal'
import cmsPaypalDetail from '@/components/cms/cmsPaypalDetail'
import cmsSchedules from '@/components/cms/cmsSchedules'
import cmsSchedulesDetail from '@/components/cms/cmsSchedulesDetail'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const router = new Router({
  routes: [
    // Home
    {path: '/', name: 'Dashboard', component: Dashboard},
    // Admin
    {path: '/clients', name: 'Clients', component: Clients},
    {path: '/addClient', name: 'addClient', component: addClient},
    {path: '/clients/clientDetails', name: 'ClientDetails', component: ClientDetails},
    {path: '/config', name: 'Config', component: Config},
    {path: '/products', name: 'Products', component: Products},
    {path: '/addProduct', name: 'addProduct', component: addProduct},
    {path: '/addInvoice', name: 'addInvoice', component: addInvoice},
    {path: '/addSubscription', name: 'addSubscription', component: addSubscription},
    // Client Area
    {path: '/domains', name: 'Domains', component: Domains},
    {path: '/email', name: 'Email', component: Email},
    {path: '/sites', name: 'Sites', component: Sites},
    {path: '/billing', name: 'Billing', component: Billing},
    {path: '/services', name: 'Services', component: Services},
    {path: '/invoices', name: 'Invoices', component: Invoices},
    {path: '/invoices/invoiceDetails', name: 'invoiceDetails', component: invoiceDetails},
    {path: '/subscriptions', name: 'Subscriptions', component: Subscriptions},
    {path: '/support', name: 'Support', component: Support},
    {path: '/cart', name: 'Cart', component: Cart},
    {path: '/checkout-success', name: 'checkoutSuccess', component: checkoutSuccess},
    // CMS
    {path: '/cms', name: 'cmsdash', component: cmsDash},
    {path: '/cms/pages', name: 'cmsPages', component: cmsPages},
    {path: '/cms/settings', name: 'cmsSettings', component: cmsSettings},
    {path: '/cms/settingsUser', name: 'cmsSettingsUser', component: cmsSettingsUser},
    {path: '/cms/colors', name: 'cmsColors', component: cmsColors},
    // CMS Leads
    {path: '/cms/leads', name: 'cmsLeads', component: cmsLeads},
    // CMS Content Pages
    {path: '/cms/services', name: 'cmsServices', component: cmsServices},
    {path: '/cms/services-detail/', name: 'cmsServicesDetail', component: cmsServicesDetail},
    {path: '/cms/services-detail/:slug', name: 'cmsServicesItemDetail', component: cmsServicesDetail},
    {path: '/cms/news', name: 'cmsNews', component: cmsNews},
    {path: '/cms/news-detail', name: 'cmsNewsDetail', component: cmsNewsDetail},
    {path: '/cms/news-detail/:slug', name: 'cmsNewsItemDetail', component: cmsNewsDetail},
    {path: '/cms/properties', name: 'cmsProperties', component: cmsProperties},
    {path: '/cms/properties-detail', name: 'cmsPropertiesDetail', component: cmsPropertiesDetail},
    {path: '/cms/properties-detail/:slug', name: 'cmsPropertiesItemDetail', component: cmsPropertiesDetail},
    {path: '/cms/units-detail', name: 'cmsPropertiesUnitsDetail', component: cmsPropertiesUnitsDetail},
    {path: '/cms/units-detail/:slug', name: 'cmsPropertiesUnitsItemDetail', component: cmsPropertiesUnitsDetail},
    {path: '/cms/land-detail', name: 'cmsPropertiesLandDetail', component: cmsPropertiesLandDetail},
    {path: '/cms/land-detail/:slug', name: 'cmsPropertiesLandItemDetail', component: cmsPropertiesLandDetail},
    {path: '/cms/testimonials', name: 'cmsTestimonials', component: cmsTestimonials},
    {path: '/cms/testimonials-detail', name: 'cmsTestimonialsDetail', component: cmsTestimonialsDetail},
    {path: '/cms/testimonials-detail/:name', name: 'cmsTestimonialsItemDetail', component: cmsTestimonialsDetail},
    {path: '/cms/partners', name: 'cmsPartners', component: cmsPartners},
    {path: '/cms/partners-detail/', name: 'cmsPartnersDetail', component: cmsPartnersDetail},
    {path: '/cms/partners-detail/:name', name: 'cmsPartnersItemDetail', component: cmsPartnersDetail},
    {path: '/cms/custom-pages-detail/', name: 'cmsCustomPagesDetail', component: cmsCustomPagesDetail},
    {path: '/cms/custom-pages-detail/:name', name: 'cmsCustomPagesItemDetail', component: cmsCustomPagesDetail},
    {path: '/cms/faqs', name: 'cmsFaqs', component: cmsFaqs},
    {path: '/cms/faqs-detail/', name: 'cmsFaqsDetail', component: cmsFaqsDetail},
    {path: '/cms/faqs-detail/:url', name: 'cmsFaqsItemDetail', component: cmsFaqsDetail},
    {path: '/cms/products', name: 'cmsProducts', component: cmsProducts},
    {path: '/cms/products-detail/', name: 'cmsProductsDetail', component: cmsProductsDetail},
    {path: '/cms/products-detail/:id', name: 'cmsProductsItemDetail', component: cmsProductsDetail},
    {path: '/cms/product-categories', name: 'cmsProductCategories', component: cmsProductCategories},
    {path: '/cms/categories-detail/:id', name: 'cmsProductCategoriesDetail', component: cmsProductCategoriesDetail},
    {path: '/cms/product-orders', name: 'cmsProductOrders', component: cmsProductOrders},
    {path: '/cms/order-detail', name: 'cmsOrderDetail', component: cmsOrderDetail},
    {path: '/cms/portfolio', name: 'cmsPortfolio', component: cmsPortfolio},
    {path: '/cms/portfolio-categories', name: 'cmsPortfolioCategories', component: cmsPortfolioCategories},
    {path: '/cms/portfolio-detail', name: 'cmsPortfolioDetail', component: cmsPortfolioDetail},
    {path: '/cms/portfolio-detail/:url', name: 'cmsPortfolioItemDetail', component: cmsPortfolioDetail},
    {path: '/cms/team', name: 'cmsTeam', component: cmsTeam},
    {path: '/cms/team-detail/', name: 'cmsTeamDetail', component: cmsTeamDetail},
    {path: '/cms/team-detail/:url', name: 'cmsTeamItemDetail', component: cmsTeamDetail},
    {path: '/cms/photos', name: 'cmsPhotos', component: cmsPhotos},
    {path: '/cms/photo-detail/', name: 'cmsPhotoDetail', component: cmsPhotoDetail},
    {path: '/cms/documents', name: 'cmsDocuments', component: cmsDocuments},
    {path: '/cms/document-detail/', name: 'cmsDocumentsDetail', component: cmsDocumentsDetail},
    {path: '/cms/document-detail/:name', name: 'cmsDocumentsItemDetail', component: cmsDocumentsDetail},
    {path: '/cms/paypal', name: 'cmsPaypal', component: cmsPaypal},
    {path: '/cms/paypal-detail/', name: 'cmsPaypalDetail', component: cmsPaypalDetail},
    {path: '/cms/paypal-detail/:name', name: 'cmsPaypalItemDetail', component: cmsPaypalDetail},
    {path: '/cms/schedules', name: 'cmsSchedules', component: cmsSchedules},
    {path: '/cms/schedules-detail/', name: 'cmsSchedulesDetail', component: cmsSchedulesDetail},
    {path: '/cms/schedules-detail/:title', name: 'cmsSchedulesItemDetail', component: cmsSchedulesDetail},
    // Not Found
    {path: '*', component: NotFound}
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  mode: 'history',
  base: process.env.environment === 'development' ? '/' : '/dashboard/'
})

export default router

// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   if (requiresAuth) {
//     next('/login')
//   } else {
//     next()
//   }
// })



// WEBPACK FOOTER //
// ./src/router/index.js